import React, { useRef, useState, useEffect } from 'react';
import CodeEditor from '@uiw/react-textarea-code-editor';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowUp, faEraser } from '@fortawesome/free-solid-svg-icons';

const TextSizeChecker = () => {
  const [originalInput, setOriginalinput] = useState('');
  const [fileSizeInBytes, setFileSizeInBytes] = useState(0);
  const elementRef = useRef(null); // Create a ref to access the DOM element
  const screenHeight = window.innerHeight
  const [height, setHeight] = useState(screenHeight * 0.55);
  const [rows, setRows] = useState(0);

  const handleInputText = (event) => {
    const inputValue = event.target.value.replace(/(\r\n|\n|\r)/g, '');
    setOriginalinput(event.target.value);
    const blob = new Blob([inputValue], { type: 'text/plain' });
    const inBytes = blob.size;
    setFileSizeInBytes(inBytes);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target.result;
      setOriginalinput(content);
      const blob = new Blob([content]);
      const inBytes = blob.size;
      setFileSizeInBytes(inBytes);
    };
    reader.readAsText(file);
  };

  const resetAll = () => {
    setOriginalinput('');
    setFileSizeInBytes(0)
  }

  const calculateRows = () => {
    const rowHeight = 15;
    const calculatedRows = Math.floor((height - 150) / rowHeight);
    setRows(calculatedRows / 2);
  };

  useEffect(() => {
    // Check if the elementRef has been assigned to a DOM element
    if (elementRef.current) {
      setHeight(elementRef.current.offsetHeight);
    }
    calculateRows()
  }, []);

  return (
    <div class="grid grid-cols-1 xl:grid-cols-3 xl:gap-4">
      <div className="col-span-2">
        <div style={{ height: height }} ref={elementRef} className="p-4 mb-4 space-y-6 bg-white border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 font-medium text-md border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-blue-600 p-2'>Your input</h3>
          </div>
          <div className="px-4 py-2 rounded">
            <textarea
              id="inputText"
              rows={rows}
              className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Text Goes Here"
              value={originalInput}
              onChange={handleInputText}
            />
          </div>
          <div className="px-4 py-2">
            <input
              type="file"
              accept='.txt, .json, .csv, .xml, .html, .js, .css, .md, .py, .java, .php, .rb, .go, .c, .cpp, .h, .cs, .sql, .sh, .ps1, .bat, .psm1, .psd1, .vbs, .ts, .tsx, .jsx, .tsx, .yaml, .yml, .ini, .cfg, .toml, .xml, .svg, .less, .scss, .sass, .swift, .kt, .ktm, .kts, .k'
              onChange={handleFileUpload}
              className='hidden'
              name='file1'
            />
            <button
              onClick={() => document.querySelector('input[name="file1"]').click()}
              type="button"
              className="text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:ring-[#2557D6]/50 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-[#2557D6]/50 me-2 mb-2"
            >
              <FontAwesomeIcon icon={faCloudArrowUp}/>
              &nbsp; Browse your file
            </button>
            &nbsp;&nbsp;
            <button
              onClick={resetAll}
              type="button"
              className="text-white bg-gray-400 hover:bg-gray-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faEraser}/>
              &nbsp; Reset
            </button>
          </div>
        </div>
      </div>

      <div className="col-span-full xl:col-auto">
        <div style={{ height: height }} className="p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 font-medium text-md border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-blue-600 p-2'>Your Result</h3>
          </div>
          <div className="px-4 py-2 text-gray-400 rounded">
            <table className="w-full text-sm text-left rtl:text-right text-gray-600 dark:text-gray-400">
              <tbody>
                <tr>
                  <th scope="col" className="px-6 py-3">
                    Total characters
                  </th>
                  <td className="px-6 py-4">
                    {originalInput.length}
                  </td>
                </tr>
                <tr>
                  <th scope="col" className="px-6 py-3">
                    File size in bytes
                  </th>
                  <td className="px-6 py-4">
                    {fileSizeInBytes}
                  </td>
                </tr>
                <tr>
                  <th scope="col" className="px-6 py-3">
                    File size in kilobytes
                  </th>
                  <td className="px-6 py-4">
                    {fileSizeInBytes / 1024}
                  </td>
                </tr>
                <tr>
                  <th scope="col" className="px-6 py-3">
                    File size in megabytes
                  </th>
                  <td className="px-6 py-4">
                    {fileSizeInBytes / 1048576}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TextSizeChecker;
